<template>
  <div>
    <el-table
      :data="detailList"
      stripe
      border
      style="width: 100%"
      header-row-class-name="header_table_row"
    >
      <el-table-column label="巡检单号" width="120" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.row.planId }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="巡检设备/类别" width="140" align="center">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.patrolScene
                ? scope.row.patrolScene
                : scope.row.facilityListName
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="巡检内容" align="center">
        <template slot-scope="scope">
          <div style="text-align: left">{{ scope.row.patrolContent }}</div>
        </template>
      </el-table-column>
      <el-table-column width="80" label="异常情况" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.facilityState == 2 ? "正常" : "异常" }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="createBy"
        width="100"
        label="负责人"
        align="center"
      >
      </el-table-column> -->
      <el-table-column
        prop="isException"
        width="100"
        label="工单状态"
        align="center"
      >
        <template slot-scope="scope">
          <div :style="scope.row.isException ? 'color:red' : ''">
            {{ scope.row.isException ? "异常" : "正常" }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    detailList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },
  created() {
    console.log(this.detailList);
  },
  methods: {
    onToInfo(row) {
      this.$Modal.remove();
      $utils.url.push({
        name: "recordInfo",
        query: { action: "edit", kv: row.id },
      });
    },
  },
};
</script>

<style>
</style>